<template>
    <div class="FM_financial">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="financeRecordForm" class="demo-form-inline">
                <el-form-item style="width:177px;">
                    <el-radio v-model="financeRecordForm.team_type" :label="1" @change="typeChange">团队</el-radio>
                    <el-radio v-model="financeRecordForm.team_type" :label="2" @change="typeChange">直营</el-radio>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size="medium"
                        v-model="financeRecordForm.brand_id"
                        filterable
                        clearable
                        style="width:100%"
                        placeholder="请选择终端类型"
                    >
                        <el-option
                            v-for="(item,index) in brandList"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input
                        size
                        clearable
                        v-model="financeRecordForm.real_name"
                        placeholder="请输入代理真实姓名"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                        size
                        clearable
                        v-model="financeRecordForm.phone"
                        placeholder="请输入代理账号"
                    ></el-input>
                </el-form-item>
              <el-form-item>
                <el-input
                    size
                    clearable
                    v-model="financeRecordForm.agent_no"
                    placeholder="请输入代理编号"
                ></el-input>
              </el-form-item>
                <el-form-item>
                    <el-select
                        size
                        v-model="financeRecordForm.income_type"
                        clearable
                        placeholder="请选择入账类型"
                    >
                        <el-option label="收入" value="1"></el-option>
                        <el-option label="支出" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                      size
                      v-model="financeRecordForm.start_account_type"
                      clearable
                      placeholder="钱包类型"
                  >
                    <el-option label="分润账户" value="0"></el-option>
                    <el-option label="活动账户" value="1"></el-option>
                    <el-option label="押金账户" value="2"></el-option>
                    <el-option label="特惠奖励账户" value="5"></el-option>
                    <el-option label="大盘分红账户" value="6"></el-option>
                    <el-option label="管理奖账户" value="7"></el-option>
                    <el-option label="底薪奖账户" value="8"></el-option>
                    <el-option label="流量卡账户" value="9"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="financeRecordForm.type" clearable placeholder="请选择科目" @change="subject($event)">
                        <el-option
                            v-for="(item,index) in typeList"
                            :label="item.name"
                            :value="item.type"
                            :key="index"
                        ></el-option>
                    </el-select>
                </el-form-item>
				<el-form-item v-if="billState">
				    <el-select
				        size
				        v-model="financeRecordForm.is_invoice"
				        clearable
				        placeholder="请选择是否影响开票">
				        <el-option label="是" value="1"></el-option>
				        <el-option label="否" value="2"></el-option>
				    </el-select>
				</el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="入账开始日期"
                        end-placeholder="入账结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSearch(financeRecordForm)"
                    >查询</el-button>
                </el-form-item>
				<el-form-item>
				  <el-button
				      size="small"
				      type="primary"
				      icon="el-icon-download"
				      :loading="downLoading"
				      @click="handleDownLoad(financeRecordForm)"
				  >导出数据</el-button>
				</el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <!-- <div style="margin-bottom: 20px;">
                <el-button size="small" type="primary" icon="el-icon-s-promotion" @click>占位</el-button>
            </div>-->
			<div style="margin-bottom: 10px;">
				<div class="tableTitle">
					<span class="st-label">总收入：</span>
					<span class="st-word-aux">{{totalIn}}</span>
				</div>
<!--                <div class="tableTitle" v-if="level >1 ">
					<span class="st-label">分润总额：</span>
					<span class="st-word-aux">{{tableTitle.my_money}}</span>
				</div> -->
				<div class="tableTitle">
					<span class="st-label">总支出：</span>
					<span class="st-word-aux">{{totalOut}}</span>
				</div>
			</div>
            <el-table
                :data="financeRecordTable"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
            >
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <!-- 所属终端类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="brand_name"
                    label="所属终端类型"
                    min-width="200"
                ></el-table-column>
                <!-- 所属一级代理名称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="agent_name"
                    label="所属机构"
                    min-width="120"
                ></el-table-column>
				<!-- 代理名称 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="agent_no"
				    label="代理编号"
				    min-width="150"
				></el-table-column>
                <!-- 代理名称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="real_name"
                    label="代理名称"
                    min-width="120"
                ></el-table-column>
                <!-- 代理账户 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="phone"
                    label="代理账户"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.phone | desMobile" placement="top">
                            <p>{{ scope.row.phone | desMobile }}</p>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 账户类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="account_type"
                    label="账户类型"
                    min-width="120"
                >
                    <!-- <template slot-scope>钱包余额</template> -->
                </el-table-column>
                <!-- 入账类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="income_type"
                    label="入账类型"
                    min-width="100"
                    :formatter="formatIncomeType"
                ></el-table-column>
                <!-- 科目 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="type"
                    label="科目"
                    min-width="150"
                ></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="is_invoice"
				    label="是否影响开票"
				    min-width="150"
				></el-table-column>
                <!-- 来源 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="form"
                    label="来源"
                    min-width="200"
                ></el-table-column>
                <!-- 金额 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="money"
                    label="金额"
                    min-width="120"
                ></el-table-column>
                <!-- 当前余额 -->
                <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="balance"
                    label="当前余额"
                    min-width="120"
                ></el-table-column>-->
                <!-- 入账时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="create_time"
                    label="入账时间"
                    min-width="150"
                ></el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations
                :currentPage="page.currentPage"
                :pageSize="page.pageSize"
                :total="page.total"
                @watchCurrent="getCurrent"
                @watchPageSize="getPageSize"
            ></paginations>
        </el-card>
    </div>
</template>

<script>
import paginations from '../../../components/pagination/paginations';
export default {
    name: "FM_financial",
    data() {
        return {
            totalOut: '0.00', //总支出
            totalIn: '0.00', //收入
            rangeDate: '', //时间范围
            brandList: [],
            typeList: [], //科目列表
            financeRecordTable: [], //表格
            financeRecordForm: {
                brand_id: '', //终端类型id
                real_name: '', //代理名称
                phone: '', //代理账户
                agent_no: '', //代理账户
                income_type: '', //入账类型
                start_account_type: '', //入账类型
                type: '', //科目
                is_invoice: '', //是否影响开票
                start_create_time: '',    //申请开始时间
                end_create_time: '',    //申请结束时间
                page: 1,
                limit: 10,
                team_type:1
            },
			billState:false,
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            loading: true,
			downLoading: false //导出loading
        }
    },
    mounted() {
        this.getBrand();
        this.getType();
        //获取科目
        this.getData( //初始化
            this.financeRecordForm
        );
    },
    components: {
        paginations
    },
    methods: {
		subject(e){
			if(e == 50){
				this.billState = true;
			}else{
				this.billState = false;
			}
		},
        typeChange(val) { //监听radio
            this.financeRecordForm.team_type = val;
            this.currentPage = 1; //重置分页
            this.financeRecordForm.page = 1; //重置
            // 表单提交
            this.getData();
        },
        onSearch(financeRecordForm) {
            this.page.currentPage = 1;
            this.financeRecordForm.page = 1;
            // 表单提交
            this.getData();
        },
        //分页
        getCurrent(page) {
            this.loading = true;
            // 获取当前页修改的值
            this.page.currentPage = page;
            this.financeRecordForm.page = this.page.currentPage;
            this.financeRecordForm.limit = this.page.pageSize;
            this.getData();
        },
        getPageSize(limit) {
            this.page.currentPage = 1; //重置分页
            // 获取条数发生改变的值
            this.loading = true;
            this.page.pageSize = limit;
            this.financeRecordForm.page = this.page.currentPage;
            this.financeRecordForm.limit = limit;
            this.getData();
        },
        getData() {
            this.$api.post("user/balance_log_list", this.financeRecordForm, res => {
                let data = res.data;
                this.page.total = data.count; //总数
                this.financeRecordTable = data.list;
				this.totalOut = data.total_out;
				this.totalIn = data.total_in;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
		handleDownLoad(financeRecordForm) { //导出
			let reqData = {
				type: 7,
				value: JSON.stringify(financeRecordForm)
			};
			
			this.downLoading = true; 
			this.$api.post('export/add', reqData, res => {
				if (res.code == 0) {
					this.$message.success(res.msg);
					this.downLoading = false;
				} else {
					this.$message.error(res.msg);
					this.downLoading = false;
				}
			})
		  // this.downLoading = true;
		  // this.$api.post("user/balance_log_list_download", this.financeRecordForm, res => {
		  //   if (res.code == 0) {
		  //     this.$message.success(res.msg);
		  //     var link=this.$file_url+res.data;
		  //     window.open(link)
		  //   } else {
		  //     this.$message.error(res.msg);
		  //   }
		  //   //渲染结束后取消加载
		  //   this.downLoading = false;
		  // })
		},
        formatIncomeType(row) {
            let inComeType;
            switch (row.income_type) {
                case 1:
                    inComeType = '收入';
                    break;

                default:
                    inComeType = '支出';
                    break;
            }
            return inComeType;
        },
        getBrand() { //获取终端类型
            this.$api.post('brand/brand_list', {}, res => {
                if (res.code == 0) {
                    this.brandList = res.data.list;
                } else {
                    this.$$message.success(res.msg);
                }
            });
        },
        getType() { //获取科目
            this.$api.post('get/balance_type_user', {}, res => {
                if (res.code == 0) {
                    this.typeList = res.data;
                } else {
                    this.$$message.success(res.msg);
                }
            });
        },
        pickerChange(DateArr) { //时间选择器
            this.financeRecordForm.start_create_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.financeRecordForm.end_create_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
        }
    }
};
</script>

<style lang="scss" scope>
.FM_financial {
    .realTitle {
        :nth-child(1) {
            font-size: 12px;
            font-weight: 700;
            color: #1e1e1e;
        }
        .imgParent {
            margin: 10px 0;
            // width: 500px;
            overflow: hidden;
            img {
                width: 100%;
                height: 250px;
                border-radius: 10px;
            }
        }
    }
    .el-dialog__header {
        padding: 20px 20px 0px;
    }
    .el-dialog__body {
        padding: 0px 20px 30px 20px;
    }
    .el-input__inner {
        font-size: 12px;
    }
    .el-form-item {
        margin-bottom: 5px;
    }
}
</style>
